import { createFileRoute, useParams } from '@tanstack/react-router';
import { HStack, Spacer, VStack } from '@/components/Layout';
import { Loader } from '@/components/Loading';
import { Text } from '@/components/Typography/Text';
import { HistoryItem, TableofContentsLeftRail } from '@/features/history';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { useGetTicketActivities } from './-query';
export const Route = createFileRoute('/_stacktrace/development-tickets/$ticketId/_layout/history/')({
  component: TicketHistoryTab
});

/**
 * 開発チケット 詳細 > 履歴タブ。
 *
 * BE `/v2/pn-force/tickets/{id}/activities` を limit=100 で叩き、共有
 * `features/history` 配下の `HistoryItem` / `TableofContentsLeftRail` で
 * Value 詳細と同じ UI を再利用する。
 */
function TicketHistoryTab() {
  const {
    ticketId
  } = useParams({
    from: '/_stacktrace/development-tickets/$ticketId/_layout/history/'
  });
  const {
    data,
    isPending
  } = useGetTicketActivities(ticketId);
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'tickets.detail.history'
  });
  if (isPending || !data) {
    return <Loader />;
  }
  if (data.histories.length === 0) {
    return <VStack className="flex-1 items-center justify-center py-12">
        <Text variant="labelSemiLarge" className="text-neutral-muted-on-fill">
          {t('empty')}
        </Text>
      </VStack>;
  }
  return <HStack className="h-full p-10 gap-8">
      <nav className="sticky top-0 h-fit w-[240px]">
        <TableofContentsLeftRail historiesGroupByValidFrom={data.historiesGroupByValidFrom} basePath={`/development-tickets/${ticketId}/history`} />
      </nav>
      <VStack className="w-full relative">
        <Spacer size={24} />
        <HistoryItem historiesGroupByValidFrom={data.historiesGroupByValidFrom} />
      </VStack>
    </HStack>;
}